module.exports = __webpack_public_path__ + "img/department.a57c1c56.png";